import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6af80512"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "reset-password px-3 py-4" }
const _hoisted_2 = { class: "pt-3 mt-4" }
const _hoisted_3 = { class: "pt-3 text-center" }

import { onBeforeMount, ref } from "vue";
import { useRouter } from "vue-router";
import { accountService } from "@/app/services/AccountService";
import { authService } from "@/app/services/AuthService";
import AppButton from "@/components/atoms/button/AppButton.vue";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import PasswordInputGroup from "@/components/molecules/form/PasswordInputGroup.vue";
import Header from "@/components/organisms/common/Header.vue";
import { useLoader } from "@/utils/loader";
import { useErrorModal, useModal } from "@/utils/modal";


export default /*#__PURE__*/_defineComponent({
  __name: 'ResetPassword',
  setup(__props) {

const errorModal = useErrorModal();
const modal = useModal();
const loader = useLoader();
const router = useRouter();

const oldPassword = ref("");
const newPassword = ref("");

onBeforeMount(async () => {
  await accountService.updateUserData();
});

function onClickBack() {
  router.back();
}

async function onClickButton() {
  loader.show();
  try {
    const body = {
      oldPassword: oldPassword.value,
      newPassword1: newPassword.value,
      newPassword2: newPassword.value
    };
    await authService.changePassword(body);
    await showSuccessModal();
    onClickBack();
  } catch (error) {
    await errorModal.showErrorModal(error as Error);
  } finally {
    loader.hide();
  }
}

async function showSuccessModal() {
  await modal.msgBoxOk("新しいパスワードが登録されました。", {
    okVariant: "success",
    centered: true
  });
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_BForm = _resolveComponent("BForm")!
  const _component_CustomValidationObserver = _resolveComponent("CustomValidationObserver")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(Header, null, {
      left: _withCtx(() => [
        _createVNode(FeatherIcon, {
          icon: "chevron-left",
          onClick: onClickBack
        })
      ]),
      default: _withCtx(() => [
        _createTextVNode("\n      パスワードリセット\n    ")
      ], undefined, true),
      _: 1
    }),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_CustomValidationObserver, {
        ref: "form",
        tag: "div",
        class: "w-100"
      }, {
        default: _withCtx(({ handleSubmit }) => [
          _createVNode(_component_BForm, null, {
            default: _withCtx(() => [
              _createVNode(PasswordInputGroup, {
                modelValue: oldPassword.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((oldPassword).value = $event)),
                label: "現在のパスワード",
                placeholder: "入力してください",
                hideHelpText: "",
                vid: "oldPassword"
              }, null, 8, ["modelValue"]),
              _createTextVNode(),
              _createVNode(PasswordInputGroup, {
                modelValue: newPassword.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newPassword).value = $event)),
                label: "新しいパスワード",
                placeholder: "入力してください",
                class: "mt-3",
                vid: "newPassword"
              }, null, 8, ["modelValue"]),
              _createTextVNode(),
              _createElementVNode("div", _hoisted_2, [
                _createVNode(AppButton, {
                  block: "",
                  onClick: ($event: any) => (handleSubmit(onClickButton))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("\n              設定する\n            ")
                  ], undefined, true),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _createTextVNode(),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_RouterLink, {
                  class: "text-size-14 text-mild text-decoration-underline",
                  to: { name: 'ResetPasswordAfterLogin' }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("\n              パスワードを忘れた場合\n            ")
                  ], undefined, true),
                  _: 1
                })
              ])
            ], undefined, true),
            _: 2
          }, 1024)
        ]),
        _: 1
      }, 512)
    ])
  ]))
}
}

})